export default __webpack_public_path__ + "static/media/ci7.c786d6fb.jpg";